import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import TableBase from "./Base";

import 'moment/locale/sv';
moment.locale('sv')

const DriversTable = ({
  scrollHeight,
  actionWidth,
  withAction,
  setting,
  ...props
}) => {
  const COLUMNS = [
    {
      title: "Zon",
      dataIndex: "name",
      width: 200,
      ellipsis: true,
      render(value, record) {
        return (
          <Link to={`/zones/${record._id}`}>
            {value}
          </Link>
        );
      },
    },
    {
      title: "Zonens centerpunkt",
      dataIndex: "centerAddress",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Antal adresser",
      dataIndex: "locations",
      width: 150,
      render(value) {
        return value?.length;
      },
    },
    {
      title: "Skapat datum",
      dataIndex: "createdAt",
      width: 250,
      render(value) {
        return value ? moment(value).format(DATE_FORMAT_FRONTEND) : "-";
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return (
      <TableBase
        columns={COLUMNS}
        scroll={{ x: 991, y: scrollHeight }}
        {...props}
      />
    );
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default DriversTable;
